import { apiSlice } from "../../app/services/apiSlice";

const JOB_URL = 'jobs/';

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createCampaignJobAdvert: builder.mutation({
            query: (data) => ({
                url: `${JOB_URL}${data?.jobId}/campaigns/${data?.campId}/advert`,
                method: 'POST',
                body: {
                    ...data?.values,
                },
            }),
        }),

        getCampaignDetail: builder.mutation({
            query: (campId) => `${JOB_URL}campaigns/${campId}`,
        }),
        createJobCampaign: builder.mutation({
            query: (data) => ({
                url: `${JOB_URL}${data?.jobId}/campaigns/${data?.campId}/finalize`,
                method: 'PUT',
            }),
        }),

        getAllGlobalCampaigns: builder.mutation({
            query: (params) => ({
                url: `campaigns`,
                params,
            }),
            transformResponse: (responseData) => {
                responseData.options = responseData?.data?.map((cat) => ({
                    ...cat,
                }));
                return responseData || {};
            },
        }),
        getAllGlobalCampaign: builder.query({
            query: (params) => ({
                url: `campaigns`,
                params,
            }),
        }),

        getSingleCampaignDetails: builder.query({
            query: (id) => ({
                url: `${JOB_URL}campaigns/${id}`,
            }),
            providesTags: (_result, _error, id) => [{ type: 'Campaign', id }],
        }),
    })
})

export const {
    useGetSingleCampaignDetailsQuery,
    useGetAllGlobalCampaignsMutation,
    useCreateCampaignJobAdvertMutation,
    useCreateJobCampaignMutation,
    useGetAllGlobalCampaignQuery,
    useGetCampaignDetailMutation
} = extendedApiSlice;